import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fileInput", "previews", "label", "urlInput", "urlStatus", "adder"]
  static values = {
    url: String,
    token: String,
    category: { type: String, default: "photo" },
    single: { type: Boolean, default: false },
    previewSize: { type: String, default: "sm" }
  }

  async upload(event) {
    const files = event.target.files
    if (!files.length) return

    // Single-photo mode: only the last selected file matters.
    const list = this.singleValue ? [files[files.length - 1]] : Array.from(files)
    for (const file of list) {
      const fd = this.#formData()
      fd.append("attachment[file]", file)
      await this.#submit(fd)
    }
    this.fileInputTarget.value = ""
  }

  async addByUrl(event) {
    if (event) event.preventDefault()
    const url = this.urlInputTarget.value.trim()
    if (!url) return

    this.#setUrlStatus("")
    const fd = this.#formData()
    fd.append("attachment[source_url]", url)
    const ok = await this.#submit(fd)
    if (ok) this.urlInputTarget.value = ""
  }

  async remove(event) {
    const id = event.currentTarget.dataset.attachmentId
    const response = await fetch(`${this.urlValue}/${id}?inline=1`, {
      method: "DELETE",
      headers: { "X-CSRF-Token": this.#csrf(), "Accept": "text/html" }
    })
    if (response.ok) {
      this.previewsTarget.querySelector(`[data-attachment-id="${id}"]`)?.remove()
      this.#refreshAdder()
    }
  }

  // private -------------------------------------------------------------------

  #formData() {
    const fd = new FormData()
    fd.append("attachment[category]", this.categoryValue)
    fd.append("attachment_token", this.tokenValue)
    fd.append("preview_size", this.previewSizeValue)
    fd.append("inline", "1")
    return fd
  }

  async #submit(formData) {
    const response = await fetch(this.urlValue, {
      method: "POST",
      headers: { "X-CSRF-Token": this.#csrf(), "Accept": "text/html" },
      body: formData
    })
    if (response.ok) {
      const html = await response.text()
      // Single-photo mode replaces the current preview.
      if (this.singleValue) this.previewsTarget.replaceChildren()
      this.previewsTarget.insertAdjacentHTML("beforeend", html)
      this.#refreshAdder()
      return true
    }
    this.#setUrlStatus((await response.text()) || `Ошибка ${response.status}`)
    return false
  }

  // In single mode, hide the "+" tile / URL field while a photo exists (adding
  // replaces, so we keep them — just visually collapse the empty-state adder).
  #refreshAdder() {
    if (!this.singleValue || !this.hasAdderTarget) return
    const hasPhoto = this.previewsTarget.children.length > 0
    this.adderTarget.classList.toggle("hidden", hasPhoto)
  }

  #setUrlStatus(text) {
    if (!this.hasUrlStatusTarget) return
    this.urlStatusTarget.textContent = text
    this.urlStatusTarget.classList.toggle("hidden", !text)
  }

  #csrf() {
    return document.querySelector("meta[name='csrf-token']").content
  }
}
